import { createMuiTheme, Theme, makeStyles, createStyles } from '@material-ui/core';
import { AccessibilityProfile } from '../../base/interfaces/headerInterface';
import { TemplateSettings } from '../../store/interfaces';

export const QuestionTheme = (profile: AccessibilityProfile): Theme => {
  return createMuiTheme({
    palette: {
      primary: {
        main: profile?.primary || '#6ABD35',
        dark: profile?.primary || '#FFFFFF',
        contrastText: profile?.primary || '#FFFFFF',
      },
      secondary: {
        main: profile?.secondary || '#6ABD35',
        contrastText: profile?.secondary || '#FFFFFF',
      },
      default: {
        main: profile?.default || '#5D676F',
      },
      borderColor: {
        main: profile?.borderColor || 'none',
      },
      headerColor: {
        main: profile?.headerColor || '#FFFFFF',
        dark: profile?.iconColor || '#5D676F',
      },
      contrastThreshold: 1,
      tonalOffset: 0.2,
      background: {
        default: profile?.bgColor || '#f2f3f4',
        paper: profile?.bgColor || '#FFFFFF',
      },
      taskTileColor: {
        main: profile?.bgColor || '#FFFFFF',
        dark: profile?.secondary || '#FFFFFF',
      },
    },
    typography: {
      fontFamily: 'Open Sans',
    },
  });
};

export const LayoutStyles = makeStyles((theme: Theme) =>
  createStyles({
    container: {
      overflow: 'auto',
      '& #root > footer, #root > .icp-recordal-footer': {
        display: 'none',
      },
      '& #root > header': {
        background: theme.palette.headerColor?.main,
      },
      '& #root > .main-content': {
        background: theme.palette.background.default,
        minHeight: 'calc(100vh -  2.5rem)',
        overflow: 'hidden',
        [theme.breakpoints.up('md')]: {
          minHeight: 'calc(100vh -  3.125rem)',
        },
      },
    },
    containerWrap: {
      marginLeft: 'auto',
      marginRight: 'auto',
      width: '80%',
      marginTop: '5rem',
      [theme.breakpoints.up('sm')]: {
        maxWidth: '40%',
      },
    },
    screenContainer: {
      overflow: 'auto',
      '& #root > footer, #root > .icp-recordal-footer': {
        display: 'none',
      },
      '& #root > header': {
        display: 'none',
      },
    },
    backArrowIcon: {
      marginLeft: '-0.313rem',
      marginRight: '0.313rem',
    },
    previewContainer: {
      '& #root > header > div > button': {
        display: 'none',
      },
    },
  }),
);

export const DefaultQuestionTheme = (props: TemplateSettings): Theme => {
  const {
    page: { primaryColor, secondaryColor },
  } = props;
  return createMuiTheme({
    palette: {
      primary: {
        main: primaryColor || '#6ABD35',
        dark: '#FFFFFF',
        contrastText: secondaryColor || '#53B1DB',
      },
      secondary: {
        main: primaryColor || '#6ABD35',
        contrastText: '#FFFFFF',
      },
      default: {
        main: '#5D676F',
      },
      borderColor: {
        main: '#00000000',
      },
      headerColor: {
        main: props.utilityBar.backgroundColor,
        dark: '#5D676F',
      },
      contrastThreshold: 1,
      tonalOffset: 0.2,
      background: {
        default: '#f2f3f4',
        paper: '#FFFFFF',
      },
      taskTileColor: {
        main: primaryColor || '#6ABD35',
        dark: secondaryColor || '#53B1DB',
      },
    },
    typography: {
      fontFamily: 'Open Sans',
    },
  });
};
